import { useCallback, useState } from 'react';

import { useConfiguratorDispatch } from '../../../store';
import { Material } from '../../../types';
import { ContainedButton } from '../../../components/buttons';

import { UpsellProduct } from '../types';
import { addUpsell } from '../store/upsellsSlice';
import { useAddUpsellToCart } from '../../cart/useAddToCart';

interface AddUpsellButtonProps {
  upsell: UpsellProduct;
  selectedMaterial: Material;
  immediateAddToCart?: boolean;
  onUpsellAdded?: () => void;
  productTag?: string;
  baseProductCartItemId?: string;
}

export function AddUpsellButton({
  upsell,
  selectedMaterial,
  immediateAddToCart = false,
  onUpsellAdded,
  productTag,
  baseProductCartItemId
}: AddUpsellButtonProps) {
  const dispatch = useConfiguratorDispatch();
  const [buttonText, setButtonText] = useState('Add to Cart');
  const [isLoading, setIsLoading] = useState(false);

  const addUpsellToCart = useAddUpsellToCart(
    upsell,
    selectedMaterial,
    baseProductCartItemId,
    productTag
  );

  const handleImmediateAddToCart = useCallback(async () => {
    setIsLoading(true);
    setButtonText('Adding...');

    const result = await addUpsellToCart();

    if (result.success) {
      if (onUpsellAdded) {
        onUpsellAdded();
      }
    } else {
      setButtonText('Error Adding To Cart');
      setIsLoading(false);
    }
  }, [addUpsellToCart, onUpsellAdded]);

  const handleClick = useCallback(() => {
    if (immediateAddToCart) {
      handleImmediateAddToCart();
    } else {
      dispatch(
        addUpsell({
          upsell,
          material: selectedMaterial
        })
      );
    }
  }, [
    immediateAddToCart,
    handleImmediateAddToCart,
    dispatch,
    upsell,
    selectedMaterial
  ]);

  return (
    <ContainedButton onClick={handleClick} disabled={isLoading}>
      {buttonText}
    </ContainedButton>
  );
}
